import BrowserPersistence from "web/utils/system/storage/storage/browserPersistence";

import storageNames from "web/constants/storageNames";
import urls from "web/constants/urls";

import { Nullable } from "web/types/Utils";

const storage = new BrowserPersistence();

const getLogoutUrl = (
  paramsAdditional?: string,
  idTokenHint?: Nullable<string>
): string => {
  const idToken = storage.getItem(storageNames.idToken) || idTokenHint;

  const params = new URLSearchParams({
    post_logout_redirect_uri: `${window.location.origin}${urls.customerLogout}`,
    id_token_hint: idToken ?? "",
  });
  const paramsAdditionalProcessed = paramsAdditional
    ? `&${paramsAdditional}`
    : "";
  if (idToken) {
    return `${
      process.env.LOGOUT_URL
    }?${params.toString()}${paramsAdditionalProcessed}`;
  }
  return urls.error;
};

export default getLogoutUrl;
